"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createVueComponent = _interopRequireDefault(require("../createVueComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MountainSnow = (0, _createVueComponent.default)('MountainSnowIcon', [['path', {
  d: 'M8 3L12 11L17 6L22 21H2L8 3Z'
}], ['path', {
  d: 'M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19'
}]]);
var _default = MountainSnow;
exports.default = _default;